<template>
  <div class="viatico-autorizacion">
    <b-card no-header>
      <form>
        <!-- <b-form-group
          class="check-description"
          label="Autorizada"
          description="Solicitud autorizada"
          :label-cols="labelCols">
          <b-form-checkbox 
              id="autorizado"
              v-model="autorizado"
              :value="true"
              :unchecked-value="false">
          </b-form-checkbox>
        </b-form-group> -->

        <app-autorizacion
          label="Autorizada"
          :label-cols="labelCols"
          description="Solicitud autorizada"
          labelOption="Seleccione una opción"
          :nombre="solicitudAutorizada"
          :lista="autorizacionList"
          @validate="validate"
          @updated="autorizacionActualizada">
        </app-autorizacion>  

        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :label-cols="labelCols"
          description="Observaciones/motivos de la autorización/rechazo">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="3"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Autorizacion from '../shared/abmSelect.vue';
import { required, maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'ViaticosAutorizacion',
  components: {
    appAutorizacion: Autorizacion,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
  },
  data () {
    return {
      autorizado: false,
      observaciones: '',

      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      autorizacionList: ['SI', 'NO'],

      labelCols: 2,
    }
  },
  computed: {
    solicitudAutorizada() {
      if ((/true/i).test(this.autorizado)) {
        return 'SI';
      }
      return 'NO';
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let save = Boolean(true);

      this.$v.$touch();

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            autorizado: (/true/i).test(this.autorizado),
            observaciones: this.observaciones.trim(),
          }
          this.$emit('autorizarViatico', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarAutorizacion')
    },
    autorizacionActualizada(autorizada){
      if (autorizada.toLowerCase().trim() == 'si') {
        this.autorizado = true;
      } else {
        this.autorizado = false;
      }
    }
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .check-description div.col {
    display: inline-block;
    top: 5px;
  }
  .check-description div.col div.custom-checkbox {
    display: inline-block;
  }
  .check-description div.col small {
    display: inline-block;
    margin-left: 2px;
  }

</style>
